module.exports = __webpack_public_path__ + "img/sc-4p-2022.4ae9419f.png";